// @flow

export const ownerFragment = `
  id
  username
  profileImage
  name
  corpName
`

export const roomFragment = `
  id
  uid
  name
  capacity
  hasDirectReservationPlans
  hasLastMinuteDiscountPlans
  prices {
    minText
    minUnitText
    maxText
    maxUnitText
  }
  thumbnails(perPage: 1) {
    results {
      url
      description
    }
  }
  space {
    username
    state
    stateText
    city
  }
  owner {
    rank
  }
  rentalReputationScore
  rentalReputationCount
`

export const featureFragment = `
  id
  uid
  title
  description
  image
`

export const guideArticleFragment = `
  id
  slug
  title
  image
  category {
    id
    slug
    breadcrumbs {
      id
      title
      slug
    }
  }
  publishedAtText(format: "default")
  author {
    name
    title
  }
`

export const companyFragment = `
  id
  name
  username
  profileImage
  paymentMethod
  paymentMethodText
`

export const companySettingFragment = `
  id
  name
  username
  profileImage(isShowAltImage: false)
  paymentMethod
  paymentMethodText
  username
  postalCode
  state
  city
  address1
  address2
  email
  tel
  department
  businessTaxId
  paymentMethod
  selectedPaymentId
`

export const companyPaymentFragment = `
  id
  last4
  name
  type
  expMonth
  expYear
`

export const companyManagedFragment = `
  id
  username
  name
  profileImage
`

export const userErrorsFragment = `
  field
  resource
  message
`

export const pageInfoFragment = `
  totalCount
  resultsCount
  totalPages
  currentPage
  hasNextPage
  hasPreviousPage
  nextPage
  previousPage
`

export const companyEmployeeFragment = `
  id
  companyId
  email
  role
  name
  profileImage
`

export const viewerFragment = `
  id
  name
  profileImage
  username
  owners {
    results {
      ... on Owner {
        ${ownerFragment}
      }
    }
  }
  isCorp
  companies(filter: MANAGED) {
    results{
      ... on Company {
        ${companyManagedFragment}
      }
    }
  }
  announcements {
    results {
      content
      link
    }
  }
  todoItems {
    results {
      content
      link
    }
  }
  newsNumber
  pointBalance {
    availableAmount
  }
  provider
`

export const historyRoomsFragment = `
  browseRoomHistories(rentType: DAY_TIME, page: 1, perPage: 10) {
    results {
      id
      uid
      name
      capacity
      hasDirectReservationPlans
      hasLastMinuteDiscountPlans
      isFavorite
      prices {
        minText
        minUnitText
        maxText
        maxUnitText
      }
      thumbnails(perPage: 5) {
        results {
          url
          description
        }
      }
      space {
        username
        state
        stateText
        city
      }
      owner {
        id
        rank
      }
      reputationScore
      reputationsCount
    }
  }
`



// WEBPACK FOOTER //
// ./src/common/fragments/index.js